import React from 'react';
import './WizardSteps.css';

const WizardSteps = (props) => {
  const { steps, currentStep } = props;

  return (
    <div className="wizard-steps">
      {steps.map((step, index) => {
        const isActive = step === currentStep;
        const isCompleted = step < currentStep;

        return (
          <div key={step} className="wizard-step">
            {/* Connecting line before step (except first) */}
            {index > 0 && (
              <div
                className={`wizard-step-line${isCompleted || isActive ? ' active' : ''}`}
              />
            )}
            {/* Step circle */}
            <div
              className={`wizard-step-circle${isActive ? ' active' : ''}${isCompleted ? ' completed' : ''}`}
            >
              {step}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default WizardSteps;
